type Props = {
  count: number;
};
export const PillsCount = (props: Props) => {
  return (
    <span className="" aria-hidden="true">
      {props.count}
    </span>
  );
};
